/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_HelpInputs */

const en_portalframe_help = /** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help centre`)
};

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const ar_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const he_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const ur_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const es_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const fr_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const de_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const pt_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const hi_portalframe_help = en_portalframe_help;

/** @type {(inputs: Portalframe_HelpInputs) => LocalizedString} */
const bn_portalframe_help = en_portalframe_help;

/**
* | output |
* | --- |
* | "Help centre" |
*
* @param {Portalframe_HelpInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_help = /** @type {((inputs?: Portalframe_HelpInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_HelpInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_help(inputs)
	if (locale === "he") return he_portalframe_help(inputs)
	if (locale === "ur") return ur_portalframe_help(inputs)
	if (locale === "es") return es_portalframe_help(inputs)
	if (locale === "fr") return fr_portalframe_help(inputs)
	if (locale === "de") return de_portalframe_help(inputs)
	if (locale === "pt") return pt_portalframe_help(inputs)
	if (locale === "hi") return hi_portalframe_help(inputs)
	if (locale === "bn") return bn_portalframe_help(inputs)
	return /** @type {LocalizedString} */ ("Help centre")
});